require("../../fhApp/appMetaService");
require('../../fhApp/currentUser/currentUser');
require("../collapsableMenu/collapsableMenuService");
require("../searchMenu/searchMenuDirective");
require('../../fhApp/hostnameMatchService');

"use strict";

angular.module('app.mainFrame.topFrameController', [
    'app.appMetaService',
    'app.currentUser',
    'app.mainFrame.collapsableMenu.collapsableMenuService',
    'app.mainFrame.searchMenu.searchMenuDirective',
    'app.hostnameMatchService'
])
    .controller('app.mainFrame.topFrameController', [
        '$scope',
        'appMetaService',
        'app.mainFrame.collapsableMenu.collapsableMenuService',
        'currentUser',
        'hostnameMatchService',
        '$state',
        function ($scope, appMeta, collapsableMenu, currentUser, hostnameMatchService, $state) {
            $scope.appMeta = appMeta;
            $scope.collapsableMenu = collapsableMenu;
            $scope.currentUser = currentUser;
            $scope.logoLink = hostnameMatchService.base_url();
            $scope.state = $state;
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/topFrame/topFrameController.js